import { render, staticRenderFns } from "./KiraKontratiAlacakFormWizard.vue?vue&type=template&id=1c60dc36"
import script from "./KiraKontratiAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./KiraKontratiAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports